// composables/useLoader.js
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export function useLoader() {
  const globalStore = useGlobalStore();
  const { isLoading } = storeToRefs(globalStore);

  const showLoader = () => globalStore.startLoader();
  const hideLoader = () => globalStore.stopLoader();
  const resetLoader = () => globalStore.resetLoader();

  return {
    isLoading,
    showLoader,
    hideLoader,
    resetLoader,
  };
}
